import 'css-chunk-1JavaScriptSource/components/_Dialogs/script-editor/style.module.scss';export default {
  "dialog": "_dialog_1aopc_1",
  "container": "_container_1aopc_6",
  "editorContainer": "_editorContainer_1aopc_22",
  "editorContainer__disabled": "_editorContainer__disabled_1aopc_27",
  "hintsContainer": "_hintsContainer_1aopc_31"
};